"use client";

import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface CopyButtonProps {
  value: string;
  className?: string;
  iconSize?: number;
  iconClassName?: string;
}

export function CopyButton({
  value,
  className,
  iconSize = 12,
  iconClassName = "text-muted-foreground/60",
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Ignore
    }
  };

  return (
    <button
      type="button"
      data-testid="copy-button"
      className={cn(
        "inline-flex items-center justify-center rounded transition-colors p-0.5",
        copied ? "cursor-default" : "cursor-pointer hover:bg-muted",
        className
      )}
      onClick={handleCopy}
    >
      {copied ? (
        <Check size={iconSize} className="text-success-500" />
      ) : (
        <Copy size={iconSize} className={iconClassName} />
      )}
    </button>
  );
}
